export enum ApiServiceStatus {
  Available = 'Available',
  InstallRequired = 'InstallRequired',
  ScopeRequestRequired = 'ScopeRequestRequired'
}
